// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"f2d7c8fc","258":"3b6e6f2d","446":"ae9b57b8","585":"a14aaeff","804":"f459aef2","898":"96cc8919"}[chunkId] + ".chunk.js";
};